import React, { useRef, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { Add } from "@mui/icons-material";
import {
  Button,
  TextField,
} from "@mui/material";
import { SERVICE_SCOPE } from "../../../utils/constants";
import { Log, sendDataWithPost } from "../../../services/services";
import { showSuccessMsg } from "../../../utils/toast";
import { SingleSelectType } from "../../table/Filter";
import Quill from "../wysiwyg-html-editor";
import { styles } from "../../../utils/styles";
import FormDialog from "../../FormDialog";

function CreateDialog({ queryPage }) {
  const formikRef = useRef(null);
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    formikRef.current?.resetForm();
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    const payload = {
      ...values,
      description: `<pre>${values.description}</pre>`,
      action: "add",
      pk: "",
      title: values.title.trim()
    };
    const url = "/admins/product_update/request/";
    Log.info(`Click button [Add] - Add new Product Update`, { ...payload, description: "" })
    await sendDataWithPost(url, payload, null, null, (res) => {
      showSuccessMsg(res.data?.detail);
      setOpen(false);
      setSubmitting(false);
      resetForm();
      queryPage();
    });
  };

  return (
    <>
      <Button variant="contained" onClick={handleClickOpen} startIcon={<Add />} sx={{ ...styles.customButton }}>
        New Product Update
      </Button>
      <Formik
        innerRef={formikRef}
        initialValues={{ title: "", description: "", service_scope: "" }}
        onSubmit={handleSubmit}
        validationSchema={Yup.object().shape({
          title: Yup.string().required("Required").trim(),
          description: Yup.string().required("Required"),
          service_scope: Yup.string().required("Required"),
        })}
      >
        {({
          values,
          errors,
          touched,
          isSubmitting,
          handleChange,
          handleSubmit,
          setFieldValue,
        }) => {
          return (
            <FormDialog
              open={open}
              onClose={handleClose}
              title="Add Update Product"
              handleSubmit={handleSubmit}
              loading={isSubmitting}
              maxWidth="sm"
            >
              <SingleSelectType
                label="Service scope"
                name="service_scope"
                options={SERVICE_SCOPE.map((item) => item)}
                selected={values.service_scope}
                onChange={(e) => handleChange(e)}
                variant="standard"
                error={Boolean(touched.service_scope && errors.service_scope)}
                helperText={touched.service_scope && errors.service_scope}
                disabled={isSubmitting}
              />

              <TextField
                label="Title"
                fullWidth
                variant="standard"
                name="title"
                value={values.title}
                error={Boolean(touched.title && errors.title)}
                helperText={touched.title && errors.title}
                onChange={(e) => handleChange(e)}
                sx={{ mb: 5 }}
                disabled={isSubmitting}
              />

              <Quill
                title="Description"
                value={values.description}
                helperText={touched.description && errors.description}
                onChange={(value) => setFieldValue("description", value)}
                sx={{ mb: 2 }}
              />
            </FormDialog>
          );
        }}
      </Formik>
    </>
  );
}

export default CreateDialog;
